import React from "react"
import { Box, Button, Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/react"
import { Swiper, SwiperSlide } from "swiper/react"
import SwiperCore, { Navigation } from "swiper"
import "swiper/css"
import Icon from "@app/components/Icon"
import Image from "@app/components/Image/Image"

type Props = {
  product: any
  activeImage?: number
  isOpen: boolean
  onClose: () => void
  images: any[]
}

SwiperCore.use([Navigation])

export const ProductMediaSwiper: React.FC<Props> = React.memo(({ product, activeImage = 0, isOpen, onClose, images }) => {
  const buttonFocus = {
    outline: "none",
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"lg"} isCentered>
      <ModalOverlay />
      <ModalContent borderRadius={0}>
        <ModalBody p={0}>
          <Swiper
            navigation={{ prevEl: `#product-${product.handle}-left`, nextEl: `#product-${product.handle}-right` }}
            preloadImages={false}
            slidesPerView={1}
            spaceBetween={0}
            initialSlide={activeImage}
          >
            {images.map((image: any, index: number) => (
              <SwiperSlide key={`slide-${index}`}>
                <Image src={image?.src} alt={image?.alt} objectFit={"cover"} w={"100%"} h={"100%"} />
              </SwiperSlide>
            ))}
          </Swiper>
          <Box pos="absolute" d="flex" alignItems="center" justifyContent="space-between" insetY={0} insetX={3}>
            <Button
              zIndex={1}
              id={`product-${product.handle}-left`}
              variant="inverted"
              w={8}
              h={8}
              borderRadius="full"
              _focus={buttonFocus}
              sx={{ "-webkit-tap-highlight-color": "transparent" }}
            >
              <Icon name="chevronLeft" width={24} />
            </Button>
            <Button
              zIndex={1}
              id={`product-${product.handle}-right`}
              variant="inverted"
              w={8}
              h={8}
              borderRadius="full"
              _focus={buttonFocus}
              sx={{ "-webkit-tap-highlight-color": "transparent" }}
            >
              <Icon name="chevronRight" width={24} />
            </Button>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
})
